import { render } from "./promos.vue?vue&type=template&id=cc2d2c86&scoped=true"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"

import "./promos.vue?vue&type=style&index=0&id=cc2d2c86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2d2c86"]])

export default __exports__